define.alias("shared/models/fb-post", "settings/models/fb-post");